import {User} from '../../../app/modules/apps/user-management/users-list/core/_models'
import {Projects} from '../../../app/modules/profile/components/Projects'

const QUERIES = {
  CONCEPTS_LIST: 'concepts-list',
  MATRICES_LIST: 'matrices-list',
  QUOTATIONS_LIST: 'quotations-list',
  QUOTATION_DETAIL: 'quotation-detail',
  TYPE_LIST: 'type-list',
  USERS_LIST: 'users-list',
  ORDENES_LIST: 'ordenes-list',
  PRODUCTS_LIST: 'products-list',
  PROMOCIONES_LIST: 'promociones-list',
  EMPRESAS_LIST: 'empresas-list',
  GC_TRACK_USERS_LIST: 'gc-tracker-users-list',
  PANELS_LIST: 'panels-list',
  CLIENTS_LIST: 'clients-list',
  COINS_LIST: 'coins-list',
  FAMILIES_LIST: 'families-list',
  UNITS_LIST: 'units-list',
}

const SERVICIOS_API = {
  USERS: '/users',
  QUOTATIONS: '/quotation',
  MATRICES: '/matrices',
  CONCEPTS: '/concepts',
  CLIENTS: '/client',
  COINS: '/coins',
  TYPES: 'Types',
  FAMILIES: '/family',
  UNITS: '/measure-units',
  TERMS: '/terms',
  EVENTS: '/Log',
  PROJECTS: '/projects',
}

const API_URL = process.env.REACT_APP_API_URL

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

const getRoleIdFromAuth = (): number | undefined => {
  if (!localStorage) return
  const lsValue = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) return

  try {
    const auth = JSON.parse(lsValue)
    return auth?.id?.role?.id
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const getUserFromAuth = (): User | undefined => {
  if (!localStorage) return
  const lsValue = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) return
  try {
    const auth = JSON.parse(lsValue)
    return auth?.id as User
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setUserToAuth = (user: User): void => {
  if (!localStorage) return
  const lsValue = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) return
  try {
    const auth = JSON.parse(lsValue)
    auth.id = user
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, JSON.stringify(auth))
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

export {
  QUERIES,
  SERVICIOS_API,
  API_URL,
  AUTH_LOCAL_STORAGE_KEY,
  getRoleIdFromAuth,
  getUserFromAuth,
  setUserToAuth,
}
